export default "__VITE_ASSET__b90451b5__"